<template>
  <zm-dialog
    class="webinar-explain-dialog"
    :show-close="showClose"
    :visible.sync="visibleSync"
    width="889px"
    append-to-body
    @close="closeDialog"
  >
    <template #title>
      <slot name="back" />
      <div class="webinar-explain-dialog_title">{{ _$t('howAreTheyDifferent') }}</div>
    </template>
    <div class="webinar-explain-dialog_table">
      <zm-table :data="tableData" stripe style="width: 100%">
        <zm-table-column prop="plan">
          <template slot="header">
            <span class="explain-header" tabindex="-1">{{ _$t('allPlansRequireAZoomOneLicense') }}</span>
          </template>
          <template slot-scope="scope">
            <span class="plan-name" tabindex="-1">{{ scope.row.plan }}</span>
            <ToolTips
              v-if="scope.row.toolTips"
              :contentText="scope.row.toolTips"
              :title="scope.row.plan"
              @openTooltip="
                mx_handleOpenTooltip($event, TOOLTIP_TYPES.BODY__ITEM_TITLE, {
                  content: scope.row.toolTips,
                  content_en: _$tem(scope.row.toolTips),
                  label: scope.row.plan,
                  label_en: _$tem(scope.row.plan),
                })
              "
            ></ToolTips>
          </template>
        </zm-table-column>
        <zm-table-column prop="subscription" align="center">
          <template slot="header">
            <span class="main-header" tabindex="-1">{{ _$t('subscription') }}</span>
            <ToolTips
              :contentText="_$t('subscriptionToolTip')"
              :title="'Subscription'"
              @openTooltip="
                mx_handleOpenTooltip($event, TOOLTIP_TYPES.HEAD__SUBSCRIPTION, {
                  content: _$t('subscriptionToolTip'),
                  content_en: _$te('subscriptionToolTip'),
                  label: _$t('subscription'),
                  label_en: _$te('subscription'),
                })
              "
            ></ToolTips>
          </template>
          <template slot-scope="scope">
            <i v-if="scope.row.subscription === true" tabindex="-1" class="zm-icon-ok" :aria-label="_$t('included')"></i>
            <i
              v-else-if="scope.row.subscription === false"
              tabindex="-1"
              class="zm-icon-minus"
              :aria-label="_$t('notIncluded')"
            ></i>
            <span v-else class="plan-table_text">{{ scope.row.subscription }}</span>
          </template>
        </zm-table-column>
        <zm-table-column prop="ppa" align="center">
          <template slot="header">
            <span class="main-header" tabindex="-1">{{ _$t('payPerAttendee') }}</span>
            <ToolTips
              :contentText="_$t('ppaToolTips')"
              :title="'Pay Per Attendee'"
              @openTooltip="
                mx_handleOpenTooltip($event, TOOLTIP_TYPES.HEAD__PAY_PER_ATTENDEE, {
                  content: _$t('ppaToolTips'),
                  content_en: _$te('ppaToolTips'),
                  label: _$t('payPerAttendee'),
                  label_en: _$te('payPerAttendee'),
                })
              "
            ></ToolTips>
          </template>
          <template slot-scope="scope">
            <i v-if="scope.row.ppa === true" tabindex="-1" class="zm-icon-ok" :aria-label="_$t('included')"></i>
            <i
              v-else-if="scope.row.ppa === false"
              tabindex="-1"
              class="zm-icon-minus"
              :aria-label="_$t('notIncluded')"
            ></i>
            <span v-else class="plan-table_text">{{ scope.row.ppa }}</span>
          </template>
        </zm-table-column>
      </zm-table>
    </div>
  </zm-dialog>
</template>
<script>
import dialogScript from './scripts';

export default {
  mixins: [dialogScript],
  props: {
    showClose: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="scss">
.webinar-explain-dialog {
  .zm-icon-ok {
    font-size: 16px;
    color: #0b5cff;
  }
  .zm-icon-minus {
    font-size: 16px;
    color: #666487;
  }
  .zm-dialog {
    padding: 20px 30px;
    &__header {
      padding-top: 20px;
    }

    .zm-dialog__headerbtn {
      font-size: 25px;
    }
    .zm-dialog__headerbtn:hover {
      .zm-dialog__close {
        color: #6e7680;
      }
    }
  }
  .webinar-explain-dialog_title {
    font-size: 32px;
    font-weight: 600;
    line-height: 38px;
    letter-spacing: 0em;
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
  .webinar-explain-dialog_table {
    .explain-header {
      font-size: 14px;
      font-weight: 450;
      line-height: 17px;
      letter-spacing: 0.01em;
      text-align: left;
      color: #666487;
    }
    .main-header {
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
      letter-spacing: 0em;
      text-align: center;
      color: #00031f;
    }
    .plan-name {
      font-size: 16px;
      font-weight: 450;
      line-height: 24px;
      letter-spacing: 0em;
      color: #00053d;
    }

    .plan-table_text {
      font-size: 16px;
      font-weight: 450;
      line-height: 24px;
      letter-spacing: 0em;
      color: #00053d;
    }
  }
}
</style>
